import React from 'react';
import _ from 'lodash';
import AlertTitle from '@mui/material/AlertTitle';
import Alert from '@mui/material/Alert';
import ProgrammaticCustomizer from 'relevant-shared/reportData/customizers/programmaticCustomizer';
import EffectiveUserSettings from 'relevant-shared/misc/effectiveUserSettings';
import Checkbox from '../../Checkbox';
import { stores } from '../../../stores';

class FrontendProgrammaticCustomizer extends ProgrammaticCustomizer {
	renderFilterHeader({ selectOptions, settings }) {
		const { portfolioNr } = stores.identity;
		if (!portfolioNr || _.includes(settings.getDimensionExclude(settings.state), 'userNr')) {
			return null;
		}
		if (EffectiveUserSettings.current().limitToPortfolio) {
			return null; // Will always automatically filter by my advertisers
		}
		const id = portfolioNr;
		const { selected, onChange } = selectOptions('userNr');
		return (
			<div style={{ position: 'absolute', right: 90, top: 13 }}>
				<Checkbox
					label="Filter by my advertisers"
					name="filterByPortfolio"
					value={selected.indexOf(id) >= 0}
					onChange={(ev) => {
						const items = _.without(selected, id);
						if (ev.target.value) {
							items.push(id);
						}
						onChange(items);
					}}
				/>
			</div>
		);
	}

	transformedReportResult(res) {
		// "Hack" - if the portfolio has been added since last reload of SystemData.genericData,
		// then let's update the user here.
		if (res.meta?.myPortfolioUserNr) {
			stores.identity.portfolioNr = res.meta.myPortfolioUserNr;
		}
		return res;
	}

	getReportWarning() {
		let message;
		if (EffectiveUserSettings.current().limitToPortfolio && !stores.identity.portfolioNr) {
			message = 'This report is empty as you currently have no advertiser portfolio assigned';
		}
		return message && (
			<Alert severity="warning">
				<AlertTitle>Warning</AlertTitle>
				{message}
			</Alert>
		);
	}
}

export default FrontendProgrammaticCustomizer;
